import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { clientConfig } from 'pos-client/clientConfig.ts';

export const isDatadogEnabled = () => clientConfig.datadog.enabled;
export const IsDatadogUserTrackingEnabled = () =>
  clientConfig.datadog.enabled && clientConfig.datadog.allowUserTracking;

export const initializeDatadog = () => {
  if (isDatadogEnabled()) {
    datadogRum.init({
      applicationId: clientConfig.datadog.applicationId,
      clientToken: clientConfig.datadog.clientToken,
      site: 'datadoghq.eu',
      service: clientConfig.datadog.serviceName,
      env: clientConfig.datadog.environment,
      version: clientConfig.version,
      sessionSampleRate: clientConfig.datadog.sessionSamplingRate,
      sessionReplaySampleRate: clientConfig.datadog.replaySamplingRate,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      trackFrustrations: true,
      defaultPrivacyLevel: clientConfig.datadog.privacyLevel,
      trackSessionAcrossSubdomains: true,
      allowedTracingUrls: [/https:\/\/.*\.avayler\.com/],
    });

    datadogLogs.init({
      clientToken: clientConfig.datadog.clientToken,
      site: 'datadoghq.eu',
      service: clientConfig.datadog.serviceName,
      env: clientConfig.datadog.environment,
      version: clientConfig.version,
      forwardErrorsToLogs: true,
      forwardConsoleLogs: 'all',
      sessionSampleRate: clientConfig.datadog.sessionSamplingRate,
      trackSessionAcrossSubdomains: true,
    });

    if (clientConfig.datadog.allowSessionRecording) {
      datadogRum.startSessionReplayRecording();
    }
  }
};

export const trackUserSession = (userIdentifier: string) => {
  datadogRum.setUser({
    id: userIdentifier,
  });
};
